import api from './api';

class MeetingService {

  get(id) {
    return api.get(`meetings/client/${id}`).then(response => {
        return response.data;
      })
  }

}

export default new MeetingService();
